<ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h6 class="modal-title">{{Title | translate}} <span *ngIf="DataModel"> ({{DataModel.GlitchCallNo}} | {{DataModel.Description}})</span></h6>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form name="frm" (submit)="onSubmit()">
        <div class="modal-body container-fluid manualAssign">
            <ErrorSummary [ErrorList]="FormErrors"></ErrorSummary>
            <div *ngIf="Model.Operation == _GlitchOperationActions.Close || Model.Operation == _GlitchOperationActions.CloseEdit" class="form-group">
                <div>
                    <select class="custom-select" id="ActionReason" [(ngModel)]="Model.ReasonOrRecoveryId" name="ActionReason">
                        <option [value]="0" translate>CMB_DEF.CMB_DEF_SELECT_REASON</option>
                        <option *ngFor="let row of lstActionReasons" [value]="row.Id">{{row.Description}}</option>
                    </select>
                </div>
            </div>
            <div *ngIf="Model.Operation == _GlitchOperationActions.AddRecovery || Model.Operation == _GlitchOperationActions.EditRecovery">
                <div class="form-group">
                    <div>
                        <select class="custom-select" id="RecoveryOption" [(ngModel)]="Model.ReasonOrRecoveryId" name="ActionReason" (change)="setMaxDiscount()">
                            <option [value]="0" translate>CMB_DEF.CMB_DEF_SELECT_RECOVERY_OPTION</option>
                            <option *ngFor="let row of lstRecoveryOptions" [value]="row.Id">{{row.Description}}</option>
                        </select>
                    </div>
                </div>
                <div class="form-group">
                    <div class="d-flex">
                        <span class="mr-2 mt-1 font-weight-bold">{{masterService.GetProperty(PropertyId).CurrencySymbol}}:</span>
                        <input type="text" [(ngModel)]="Model.RecoveryCost" name="RecoveryCost" class="form-control txt-4" placeholder="{{'PH.PH_COST' | translate}}" /><span class="ml-2 mt-1" *ngIf="ApprovedMaximumCost">({{'LBL.MAX_COST' | translate}}: {{masterService.GetProperty(PropertyId).CurrencySymbol}} {{ApprovedMaximumCost}})</span>
                    </div>
                </div>
            </div>
            <div *ngIf="Model.Operation == _GlitchOperationActions.ReOpen || Model.Operation == _GlitchOperationActions.ReOpenEdit">
                <div class="form-group">
                    <div>
                        <select class="custom-select" id="ReopenOption" [(ngModel)]="Model.ReasonOrRecoveryId" name="ActionReason">
                            <option [value]="0" translate>CMB_DEF.CMB_DEF_SELECT_REASON</option>
                            <option *ngFor="let row of lstActionReasons" [value]="row.Id">{{row.Description}}</option>
                        </select>
                    </div>
                </div>                
            </div>
            <div class="form-group">
                <div>
                    <RemarksPopupTrigger [(Model)]="Model.Remarks" [EnableMaxLimit]="true">
                        <textarea class="form-control" rows="5" name="Remarks" [(ngModel)]="Model.Remarks" placeholder="{{'PH.PH_ENTER_REMARK' | translate}}" maxlength="5000"></textarea>
                    </RemarksPopupTrigger>
                </div>
            </div>

        </div>

        <div class="modal-footer">
            <button class="btn btn-primary" type="submit" [disabled]="IsSubmitting" translate>BTN.BTN_OK</button>
            <button class="btn btn-secondary" type="button" (click)="c('')" translate>BTN.BTN_CANCEL</button>
        </div>
    </form>
</ng-template>

<ng-template #confirm let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h6 class="modal-title" translate>TITLE.TITLE_CONFIRMATION</h6>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body container-fluid" *ngIf="ConfirmModel">
        <div class="form-group">
            <div class="row pointer" (click)="OpenWindow('/Pages/GlitchPrint?GlitchId='+ConfirmModel.GlitchId)">
                <div class="col-1 text-center"><div class="statusIcon-Standard glitchstatus-{{ConfirmModel.IsOpen}}" [ngClass]="!ConfirmModel.IsOpen ? 'border-0' : ''" title="{{'TITLE.TITLE_GLITCHSTATUS_' + ConfirmModel.IsOpen | uppercase | translate}}"></div></div>
                <div class="col-1" title="{{'TITLE.TITLE_GLITCH_NO' | translate}}">{{ConfirmModel.GlitchCallNo}}</div>
                <div class="col-3 ">
                    <div class="ellipsis" title="{{('TITLE.TITLE_INCIDENT_LOCATION' | translate) + ' - ' +ConfirmModel.LocationName}}"><i class="fas fa-map-marker-alt"></i>&nbsp;{{ConfirmModel.LocationName}}</div>
                    <div *ngIf="ConfirmModel.GuestInfo" class="ellipsis text-muted " title="{{('TITLE.TITLE_GUEST_NAME' | translate) + ' - '+ ConfirmModel.GuestInfo.FullName}}"><span class="" [ngClass]="{'ic-status active': ConfirmModel.GuestInfo.Vip}"><i class="fas fa-briefcase"></i></span> {{ConfirmModel.GuestInfo.FullName}}</div>
                    <div *ngIf="ConfirmModel.GlitchStaffName" class="ellipsis text-muted " title="{{('TITLE.TITLE_STAFF_NAME' | translate) + ' - '+ ConfirmModel.GlitchStaffName}}"> {{ConfirmModel.GlitchStaffName}}</div>
                </div>
                <div class="col-auto pr-1 ">
                    <div class="fa-fw" *ngIf="ConfirmModel.Attachments != null && ConfirmModel.Attachments.length >= 1" title="{{ConfirmModel.Attachments.length > 0 ? (('TITLE.TITLE_ATTACHMENTS' | translate) + ' - ' + ConfirmModel.Attachments.length) : ('TITLE.TITLE_NO_ATTACHMENTS' | translate)}}">
                        <i class="fas fa-paperclip"></i>
                    </div>
                </div>
                <div class="col-3 pl-0">
                    <div class="ellipsis" title="{{('TITLE.TITLE_GLITCH_DESCR' | translate) + ' - ' + ConfirmModel.Description}}">{{ConfirmModel.Description}}</div>
                    <div class="ellipsis text-muted" *ngIf="ConfirmModel.GlitchStaff && ConfirmModel.GlitchStaff.length>0" title="{{'TITLE.TITLE_STAFF_INVOLVED' | translate}}">
                        {{ConfirmModel.GlitchStaff[0].Name}}
                        <div *ngIf="ConfirmModel.GlitchStaff && ConfirmModel.GlitchStaff.length > 1"><span class="font-weight-bold">+ {{ ConfirmModel.GlitchStaff.length - 1}} {{'LBL.MORE' | translate}}</span></div>
                    </div>
                </div>
                <div class="col-3">
                    <div class="ellipsis text-center" title="{{('TITLE.TITLE_REMARKS' | translate) + ' - ' +ConfirmModel.Details}}" *ngIf="ConfirmModel.Details && ConfirmModel.Details.length > 0"><i class="far fa-sticky-note"></i>&nbsp;{{ConfirmModel.Details}}</div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal-footer">
        <button class="btn btn-primary" type="button" (click)="c('')" translate>BTN.BTN_DISMISS</button>
    </div>
</ng-template>
